import Button from '../../components/Button'
import { useState } from 'react';
import InputDropdown from '../../components/InputDropdown';

// services data
const units = [
    { label: 'Per Pound', link: '#' },
    { label: 'Per Item', link: '#' },
   
  ];


  // const handleSelect = (option) => {
  //   console.log('Selected option:', option);
  // }; 

const CreateServiceForm = ({OnCancel}) => {
  const [pricePerUnit, setPricePerUnit] = useState(0);
  const [minimumSize, setMinimumSize] = useState(0);

    const handleSubmit = (event) => {
        // Handle form submission logic
        event.preventDefault();
        console.log('Form submitted');
      };
     

//   function to increment price per unit and minimum size

const incrementPricePerUnit = (e) => {
    e.preventDefault()
    // setPricePerUnit(prevPricePerUnit => prevPricePerUnit + 1);
    setPricePerUnit((prevPricePerUnit) => parseFloat((prevPricePerUnit + 0.01).toFixed(2)));
   
  };

  const incrementMinimumSize = (e) => {
    e.preventDefault()
    // setMinimumSize(prevMinimumSize => prevMinimumSize + 1);
    setMinimumSize((prevMinimumSize) => parseFloat((prevMinimumSize + 0.01).toFixed(2)));
  }


   // Function to handle decrementing the price per unit and minimumsize
   const decrementPricePerUnit = (e) => {
    e.preventDefault()
    if (pricePerUnit > 0) {
      // setPricePerUnit(prevPricePerUnit => prevPricePerUnit - 1);
      setPricePerUnit((prevPricePerUnit) => parseFloat((prevPricePerUnit - 0.01).toFixed(2)));

    }
   
  };

  const decrementMinimumSize = (e) =>{
    e.preventDefault()
    if (minimumSize > 0) {
        // setMinimumSize(prevMinimumSize => prevMinimumSize - 1);
        setMinimumSize((prevMinimumSize) => parseFloat((prevMinimumSize - 0.01).toFixed(2)));
    }
  }

  const handleMinimumSizeChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setMinimumSize(0);
    } else {
      const numericValue = parseFloat(value);
      setMinimumSize(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  const handlePricePerUnitChange = (e) => {
    const value = parseFloat(e.target.value);
    if (value === '') {
      setPricePerUnit(0);
    } else {
      const numericValue = parseFloat(value);
      setPricePerUnit(isNaN(numericValue) ? 0 : parseFloat(numericValue.toFixed(2)));
    }
  };

  return (
    <form action="" className='create-customer-form-expanded flex flex-col gap-10' onSubmit={handleSubmit}> 
        <section className='flex gap-10'>
            <div className='flex flex-col service-name-input'>
                <label htmlFor="">Service name</label>
                <input type="text" placeholder='Enter service name' className='mt-2'/>
            </div>
            
        </section>

        <section className='flex gap-10 service-form-details'>
            <label htmlFor="" className="flex flex-col ">
            Unit of measure
            <InputDropdown
              options={units}
              onSelect={(option) => console.log(option)}
              inputClass="custom-input-class mt-2"
              inputWidth="200px"

            />
            </label>

            <div className=" custom-number-input">
                <button onClick={decrementPricePerUnit} className='decrement-btn price-per-unit-btn'>⌃</button>
                <label htmlFor="" className='quantity-input'>Price Per Unit
                <input
                    type="number"
                    value={pricePerUnit === 0 ? '' : pricePerUnit}
                    onChange={handlePricePerUnitChange}
                    min="1"
                    step="0.01"
                    className='mt-2'
                    placeholder='$'
                />
                </label>
                <button onClick={incrementPricePerUnit} className='increment-btn'>⌃</button>
            </div>

            <div className=" custom-number-input">
                <button onClick={decrementMinimumSize} className='decrement-btn price-per-unit-btn'>⌃</button>
                <label htmlFor="" className='quantity-input'>Minimum size
                <input
                    type="number"
                    value={minimumSize === 0 ? '' : minimumSize}
                    onChange={handleMinimumSizeChange}
                    min="1"
                    step="0.01"
                    className='mt-2'
                    placeholder='lbs'
                />
                </label>
                <button onClick={incrementMinimumSize} className='increment-btn'>⌃</button>
            </div>
        </section>

        
        {/* <div className="create-order-divider"></div> */}
        <section className='services-btn-section flex gap-20'>
            <Button style={{background: 'none', color: '#434C5A', fontWeight: '400'}} onClick={OnCancel}>Cancel</Button>
            <div className='create-customer-btn'>
                <Button>Add Service</Button>
            </div>
            
        </section>
    </form>
  )
}

export default CreateServiceForm